export default __webpack_public_path__ + "static/media/palette-orange.c4c70de7.svg";